import { HTTP } from './http'

export const personal = {
  asistencia (user) {
    return HTTP.post('personal/asistencia', { user })
  },
  partners (user) {
    return HTTP.post('personal/partners', { user })
  }
}
